import * as store from "@/store";
import * as mutation from "./mutation-types";
import * as action from "./action-types";
import * as lcMutation from "@/store/levy-collections/mutation-types";
import * as lcpMutation from "@/store/levy-collection-providers/mutation-types";
import * as invoiceMutation from "@/store/invoices/mutation-types";
import * as systemLogMutation from "@/store/system-logs/mutation-types";
import * as lookupsAction from "@/store/lookups/action-types";
import { deepCopyAxiosException } from "@/store/helpers";
import { SHOW_NOTIFICATION } from "@/store/notifications/mutation-types";
import { GLOBAL_ERROR } from "@/store/system/mutation-types";
import axios from "axios";

export const actions = {
  async [action.SYSTEM_DETAILS_GET]({ commit }) {
    commit(mutation.SYSTEM_DETAILS_GET_STARTED);
    try {
      const { data } = await axios.get("/api");
      commit(mutation.SYSTEM_DETAILS_GET_SUCCEEDED, data);
      return true;
    } catch (e) {
      commit(mutation.SYSTEM_DETAILS_GET_FAILED);
      commit(mutation.GLOBAL_ERROR_FATAL, deepCopyAxiosException(e));
      return false;
    }
  },
  async [action.SYSTEM_DETAILS_REFRESH]({ state, dispatch }, force = false) {
    const needsRefreshed = !state.details.loaded && !state.details.loading;
    if (needsRefreshed || force) {
      await dispatch(action.SYSTEM_DETAILS_GET);
    }
  },

  async [action.APP_SETTINGS_GET]({ commit }) {
    commit(mutation.APP_SETTINGS_GET_STARTED);
    try {
      const { data } = await axios.get("/api/system-diagnostics/settings");
      commit(mutation.APP_SETTINGS_GET_SUCCEEDED, data);
      return true;
    } catch (e) {
      commit(mutation.APP_SETTINGS_GET_FAILED);
      commit(mutation.GLOBAL_ERROR_FATAL, deepCopyAxiosException(e));
      return false;
    }
  },

  async [action.REBUILD]({ commit, dispatch }, { productionDataOnly, importProviders }) {
    commit(mutation.REBUILD_STARTED);
    try {
      const url = `/api/automation/rebuild?productionDataOnly=${productionDataOnly}&importProviders=${importProviders}`;
      await axios.post(url);
      commit(mutation.REBUILD_SUCCEEDED);
      store.resetState();
      commit(SHOW_NOTIFICATION, "Database rebuilt successfully.");
      dispatch(lookupsAction.LOAD_DYNAMIC_LOOKUPS);
      return true;
    } catch (e) {
      commit(mutation.REBUILD_FAILED, deepCopyAxiosException(e));
      return false;
    }
  },

  async [action.CLEAR_LEVY_COLLECTION]({ commit, dispatch }, levyCollectionId) {
    commit(mutation.CLEAR_LEVY_COLLECTION_STARTED);
    try {
      await axios.post(`/api/levy-collections/${levyCollectionId}/clear`);
      commit(lcMutation.STATE_RESET);
      commit(lcpMutation.STATE_UNLOAD);
      commit(systemLogMutation.STATE_UNLOAD);
      commit(mutation.CLEAR_LEVY_COLLECTION_SUCCEEDED);
      commit(SHOW_NOTIFICATION, "Levy collection cleared successfully.");
      dispatch(lookupsAction.LOAD_DYNAMIC_LOOKUPS);
      return true;
    } catch (e) {
      commit(mutation.CLEAR_LEVY_COLLECTION_FAILED);
      commit(mutation.GLOBAL_ERROR, deepCopyAxiosException(e));
      return false;
    }
  },

  async [action.SEED_SAMPLE_INVOICES]({ commit }) {
    commit(mutation.SEED_SAMPLE_INVOICES_STARTED);
    try {
      await axios.post("/api/automation/seed-sample-invoices");
      commit(lcMutation.STATE_UNLOAD);
      commit(lcpMutation.STATE_UNLOAD);
      commit(systemLogMutation.STATE_UNLOAD);
      commit(invoiceMutation.STATE_UNLOAD);
      commit(mutation.SEED_SAMPLE_INVOICES_SUCCEEDED);
      commit(SHOW_NOTIFICATION, "Sample invoices seeded successfully.");
      return true;
    } catch (e) {
      commit(mutation.SEED_SAMPLE_INVOICES_FAILED);
      commit(mutation.GLOBAL_ERROR, deepCopyAxiosException(e));
      return false;
    }
  },

  async [action.SAP_CONFIGURATION_GET]({ commit }, levyCollectionType) {
    commit(mutation.SAP_CONFIGURATION_GET_STARTED, levyCollectionType);
    try {
      const url = `/api/system-diagnostics/sap-configuration?levyCollectionType=${levyCollectionType}`;
      const { data } = await axios.get(url);
      commit(mutation.SAP_CONFIGURATION_GET_SUCCEEDED, data);
      return true;
    } catch (e) {
      commit(mutation.SAP_CONFIGURATION_GET_FAILED);
      commit(GLOBAL_ERROR, deepCopyAxiosException(e));
      return false;
    }
  }
};
